import { render, staticRenderFns } from "./package-component.vue?vue&type=template&id=5b3b0afa&scoped=true"
import script from "./package-component.vue?vue&type=script&lang=ts"
export * from "./package-component.vue?vue&type=script&lang=ts"
import style0 from "./package-component.vue?vue&type=style&index=0&id=5b3b0afa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3b0afa",
  null
  
)

export default component.exports